import type { Observable } from 'rxjs/internal/Observable';
import { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export type SecondaryRealtimeBackend = 'Icom' | 'Dlp';

export interface ProductsRequest {
  productIds: BcsProductKey[];
  backend: SecondaryRealtimeBackend;
}

export interface SecondaryStreamingApi {
  subscribe(request: ProductsRequest): Observable<unknown>;
  keepAlive(request: ProductsRequest): Observable<unknown>;
  unsubscribe(request: ProductsRequest): Observable<unknown>;
}

export function secondaryStreamingApiConnector(httpClient: IHttpClient): SecondaryStreamingApi {
  return {
    subscribe: request => {
      return httpClient.post({
        url: 'api/v1/products/subscribe',
        body: request,
        targetHost: 'SecondaryBridge',
      });
    },
    keepAlive: request => {
      return httpClient.post({
        url: 'api/v1/products/keep-alive',
        body: request,
        targetHost: 'SecondaryBridge',
      });
    },
    unsubscribe: request => {
      return httpClient.post({
        url: 'api/v1/products/unsubscribe',
        body: request,
        targetHost: 'SecondaryBridge',
      });
    },
  };
}
